export function sum(sumString: string | number) {
    sumString = sumString.toString();
    return parseFloat(sumString).toFixed(2);
}
